import { render, staticRenderFns } from "./RealTime.vue?vue&type=template&id=be82162c&scoped=true"
import script from "./RealTime.vue?vue&type=script&lang=js"
export * from "./RealTime.vue?vue&type=script&lang=js"
import style0 from "./RealTime.vue?vue&type=style&index=0&id=be82162c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be82162c",
  null
  
)

export default component.exports